"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shadows = void 0;
exports.shadows = {
    primary: "0px 4px 20px rgba(0, 0, 0, 0.2)",
    accordion: "0px 2px 4px rgba(37, 34, 42, 0.24)"
};
